import {Maybe} from '../graphql/generated/types';

export function omitNullUndefined(obj: Maybe<Object>): Maybe<Object> {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj;
  }
  const result = Object.entries(obj)
    .filter(([_, v]) => ![undefined, null].includes(v))
    .reduce((acc, [key, value]) => {
      const omitValue = omitNullUndefined(value);
      return {
        ...acc,
        ...(omitValue && {[key]: omitValue}),
      };
    }, {});

  if (Object.keys(result).length === 0) {
    return undefined;
  }

  return result;
}
